













































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { ContentSetVersionModel } from "../../../models/content/content-set-version.model";

const ContentSetVersionModule = namespace("contentSetVersionModule");

@Component({
  components: {}
})
export default class StopTest extends Vue {
  @ContentSetVersionModule.Action public retrieveConfigurationVersion;
  @ContentSetVersionModule.Action public promoteConfiguration;
  @ContentSetVersionModule.Action public promoteWinner;
  @ContentSetVersionModule.Getter public configuration;

  get getContentSetVersionModel(): IContentSetVersion {
    return this.configuration;
  }

  get hasConfigurationVersion(): boolean {
    if (
      this.contentSetVersion === null ||
      typeof this.contentSetVersion === "undefined" ||
      this.contentSetVersion.contentSetVersionId < 1 ||
      this.contentSetVersion.templates === null ||
      typeof this.contentSetVersion.templates === "undefined" ||
      this.contentSetVersion.templates.length <= 0
    ) {
      return false;
    }

    return true;
  }

  get hasMultipleLiveTemplates(): boolean {
    return this.liveVersion.templates.length > 1;
  }

  @Provide() public show: boolean = false;

  @Prop() public liveVersion: IContentSetVersion;

  private selected: string | null = null;

  private contentSetVersion: IContentSetVersion = new ContentSetVersionModel();

  @Watch("getContentSetVersionModel", { deep: true })
  public onContentSetUpdate() {
    this.contentSetVersion = this.getContentSetVersionModel;
  }

  public showModal() {
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public created() {
    this.getConfigureContentSetVersion();
  }

  get showStopTestButton(): boolean {
    return this.hasConfigurationVersion || this.hasMultipleLiveTemplates;
  }

  private getConfigureContentSetVersion() {
    this.retrieveConfigurationVersion().then((result) => {
      if (this.getContentSetVersionModel) {
        this.contentSetVersion = this.getContentSetVersionModel;
      }
    });
  }

  private submitForm() {
    if (this.selected !== null) {
      if (this.selected === "promote") {
        this.promoteConfiguration();
      } else if (this.selected === "winner") {
        this.promoteWinner();
      }
      this.show = false;
    }
  }
}
